import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { SummarizeResumeLoader } from '../helpers/ai/summarizeResume/SummarizeResumeLoader';
import { SummarizeResumeViewer } from '../helpers/ai/summarizeResume/SummarizeResumeViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const SummarizeResume = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.SUMMARIZE_RESUME.lightIcon : AI_UTILITIES.SUMMARIZE_RESUME.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.SUMMARIZE_RESUME.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.SUMMARIZE_RESUME.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.SUMMARIZE_RESUME.path} component={SummarizeResumeLoader} />
                <Route path={`${AI_UTILITIES.SUMMARIZE_RESUME.path}/:inputIdentifier`} component={SummarizeResumeViewer} />
            </Switch>
        </div>
    );
};

SummarizeResume.displayName = 'SummarizeResume';
